export const SET_COUNTIES = "SET_COUNTIES"
export const SET_ACCOUNT_TYPES = "SET_ACCOUNT_TYPES"
export const SET_ROUTING_TYPES = "SET_ROUTING_TYPES"
export const SET_ORGANIZATION_DATA = "SET_ORGANIZATION_DATA"